(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemBulkEditSummaryDialogCtrl', ItemBulkEditSummaryDialogCtrl);

    ItemBulkEditSummaryDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'ItemService', 'itemEditState'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog summarising an item bulk edit operation.
     */
    function ItemBulkEditSummaryDialogCtrl(DialogInstance, DialogService, ItemService, itemEditState) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.editedItems = [];
        vm.itemsWithError = [];
        vm.itemsToEdit = [];
        vm.editedItemsCount = 0;
        vm.itemsWithErrorCount = 0;
        vm.itemsToEditCount = 0;

        activate();

        function activate() {
            var editedItems = _.chain(itemEditState).filter({ status: 'Moved' }).map('item').value();
            var itemsWithError = _.chain(itemEditState).filter({ status: 'Error' }).map('item').value();
            var itemsToEdit = _.chain(itemEditState).filter({ status: 'ToBeMoved' }).map('item').value();

            vm.editedItems = ItemService.summariseItemList(editedItems);
            vm.itemsWithError = ItemService.summariseItemList(itemsWithError);
            vm.itemsToEdit = ItemService.summariseItemList(itemsToEdit);

            vm.editedItemsCount = editedItems.length;
            vm.itemsWithErrorCount = itemsWithError.length;
            vm.itemsToEditCount = itemsToEdit.length;
        }

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
